import type { OrderInfo } from '@@partner:types:app'

import React from 'react'
import { Badge, Placeholder } from 'rsuite'

import OrderCard from '@components/order/kanban/OrderCard'

import './LogisticKanbanColumn.scss'

export interface LogisticKanbanColumnProps {
  brandSlug: string
  label: string
  color: string
  orders: OrderInfo[]
  loading?: boolean
}

function LogisticKanbanColumn ({ brandSlug, label, color, orders, loading }: LogisticKanbanColumnProps) {
  return (
    <div className="LogisticKanbanColumn">
      {/* Шапка колонки (sticky) */}
      <div className="LogisticKanbanColumn__Header">
        <div
          className="LogisticKanbanColumn__ColorDot"
          style={{ backgroundColor: color }}
        />
        <div className="LogisticKanbanColumn__Title">
          {label}
        </div>
        <Badge className="LogisticKanbanColumn__Count" content={orders.length} />
      </div>

      {/* Контент с вертикальным скроллом */}
      <div className="LogisticKanbanColumn__Content">
        {loading ? (
          <>
            {[ 1, 2, 3, 4, 5 ].map(i => (
              <div key={i} className="OrderCard OrderCard--skeleton">
                <Placeholder.Paragraph rows={2} active />
              </div>
            ))}
          </>
        ) : orders.length === 0 ? (
          <div className="LogisticKanbanColumn__Empty">
            Нет заказов
          </div>
        ) : (
          orders.map(order => (
            <OrderCard
              key={order.id}
              order={order}
              brandSlug={brandSlug}
            />
          ))
        )}
      </div>
    </div>
  )
}

export default React.memo(LogisticKanbanColumn)
